import * as $ from "jquery";

$(".recommended h3.content-hub--heading").each(function () {
  const $heading = $(this);
  const $link = $heading.next("p").find("a");
  if ($link.length) {
    $heading.wrap("<a href='" + $link.attr("href") + "'></a>");
  }
});
